import React from 'react';

function NewFiltersCheckbox({filter,
    isSelected,
    keyToCheck,
    handleChange}) {
    return <li className="filter-list__item">
        <label className="filter-list__item__label">
            <input type="checkbox"
                onChange={() => handleChange(keyToCheck, filter.value)}
                checked={isSelected || false}
                value={filter.value}
                className="filter-list__item__label__input"/>
            <p className="filter-list__item__label__text">{ filter.title }</p>
        </label>
    </li>
};

export default NewFiltersCheckbox;